var _circle, _circle2, _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedLocationError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 43.9988,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 56.736,
    rx: 9.26316,
    ry: 1.15789,
    fill: "#C5E3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.384 55.1505C44.1816 55.3764 43.8268 55.375 43.627 55.1469C40.0491 51.0631 34.4401 45.4103 34.7491 39.2799C35.2726 34.1176 39.216 30.1055 44.0028 30.1055C48.7897 30.1055 52.7331 34.1176 53.2566 39.2799C53.4704 45.9967 48.3649 50.7089 44.384 55.1505Z",
    fill: "#0E5CF4",
    stroke: "#00193C",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6316 39.3699C48.6316 41.9278 46.5579 44.0014 44 44.0014C41.442 44.0014 39.3684 41.9278 39.3684 39.3699C39.3684 36.8119 41.442 34.7383 44 34.7383C46.5579 34.7383 48.6316 36.8119 48.6316 39.3699Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedLocationError);
export default __webpack_public_path__ + "static/media/ic-shared-location-error.d51f3174a1bdbb29502160af4453e737.svg";
export { ForwardRef as ReactComponent };